<template>
	<transition name="element--progress">
		<ElementProgress v-if="activeSubPartId === subPartId" :min="0.0" :max="1.0" :progress="progressValue" />
	</transition>
</template>

<script>
import { mapStateNested } from '../../tools/helpers';

export default {
	data() {
		return {};
	},
	props: {
		subPartId: String,
	},
	computed: {
		...mapStateNested('packageSyncer', ['activeSubPartId', 'packagesProcessed', 'packagesTotal']),
		progressValue() {
			return this.packagesProcessed / this.packagesTotal;
		},
	},
	methods: {},
};
</script>
<style lang="scss"></style>
